var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 9V16H9V9H16V7H9V0H7V7H0V9H7Z","fill":"currentColor"}));
}

PlusInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
